import { Flex } from '@/components/Flex'
import { PageSpinner } from '@/components/layouts/PageSpinner'
import styles from './styles.module.scss'

export const FullPageLoader = () => {
  return (
    <Flex align="center" justify="center" vertical className={styles.wrapper}>
      <PageSpinner />
    </Flex>
  )
}
